<div class="container pt-4 pb-4 wrapper-newsletter" id="newsletter-section">
  <form (ngSubmit)="submitForm()" [formGroup]="newsLetterForm" class="w-100">
    <div class="form-group first-step" (click)="showLegalText()">
      <div class="title">
        {{ 'notifyme.joinToNewsletter' | cxTranslate }}
      </div>
      <label>
        <input
          class="form-control input-newsletter"
          type="email"
          name="email"
          formControlName="email"
          placeholder="{{ 'notifyme.email' | cxTranslate }}"
          id="input-newsletter"
          />
        <cx-form-errors
          [control]="newsLetterForm.get('email')"
        ></cx-form-errors>
      </label>
    </div>
    @if (showMoreForm) {
      <div>
        <div class="form-group radio-inline d-flex radio-buttons-form">
          <span class="form-check">
            <label>
              <input
                id="particular"
                class="form-check-input"
                role="radio"
                type="radio"
                (change)="particular($event.isTrusted)"
                [value]="false"
                formControlName="exclusiveRole"
                />
              {{ 'notifyme.particular' | cxTranslate }}
            </label>
          </span>
          <span class="form-check">
            <label class="checkbox">
              <input
                class="form-check-input"
                id="company"
                role="radio"
                type="radio"
                (change)="company($event.isTrusted)"
                [value]="true"
                aria-checked="true"
                formControlName="exclusiveRole"
                />
              {{ 'notifyme.empresa' | cxTranslate }}
            </label>
          </span>
        </div>
        <p>
          <span [innerHTML]="'notifyme.legalText' | cxTranslate"></span>
          <span class="underline">
            <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
              {{ 'notifyme.legalText2' | cxTranslate }}
            </a>
          </span>
        </p>
        <div class="form-group">
          <div class="form-check agree-check">
            <label>
              <input
                type="checkbox"
                name="agree"
                formControlName="agree"
                />
              <span [innerHTML]="'notifyme.commonAgreement' | cxTranslate" class="form-check-label"></span>
              <cx-form-errors
                [control]="newsLetterForm.get('agree')"
              ></cx-form-errors>
            </label>
          </div>
        </div>
        <div class="container-button-newsletter">
          <button type="submit" class="btn btn-white"> {{ 'notifyme.textButton' | cxTranslate }}
          </button>
        </div>
      </div>
    }
  </form>
</div>
